import React, { Component } from 'react'
import VideosList from './videos/VideosList'
import ChangePayment from './settings/ChangePayment'
import UsageInfo from './settings/UsageInfo'
import Welcome from './welcome/Welcome'

export default class ContentPane extends Component {
  constructor() {
    super()
    

    this.state = {
      ViewClass: null,
    }
  }

  componentWillMount() {
    this.updateView(this.props.viewParams.view)
  }

  componentWillReceiveProps(newProps) {
    this.updateView(newProps.viewParams.view)
  }
  
  updateView(view) {
    if (this.currentView !== view) {
      this.currentView = view
      switch (view || null) {
        case 'settings':
          import('./settings/SettingsContainer')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'profile':
          import('./settings/SettingsContainer')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'password':
          import('./settings/ChangePassword')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'billing':
          import('./settings/SettingsContainer')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'appearance':
          import('./settings/SettingsContainer')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'payments':
          import('./settings/Payments')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'change_payment':
          this.setState({ViewClass: ChangePayment})
          break
        case 'upload-video':
          this.setState({ViewClass: Welcome})
          break
        case 'your_usage':
          this.setState({ViewClass: UsageInfo})
          break
        case 'stats':
          import('./stats/Stats')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'merge':
          import('./joiner/Joiner')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'buildembed':
          import('./embed/Embed')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'infringement':
          import('./report/DMCA')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'videos':
        case null:
        default:
          this.setState({ViewClass: VideosList})
          break
      }
    }
  }

  render() {
    if (!this.state.ViewClass) {
      return (<div />)
    }

    return (
      <this.state.ViewClass
        query={this.props.viewParams.query}
        shortcode={this.props.viewParams.shortcode}
        version={this.props.viewParams.version}
        key={this.props.viewParams.view}
        view={this.props.viewParams.view}
      />
    )
  }
}
